/* eslint-disable @typescript-eslint/no-explicit-any */
import { computed, inject, Injectable, Injector, Signal, signal } from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";
import { Observable } from "rxjs";
import { GcTranslateParser } from "./GcTranslateParser.service";

//TODO:
// - MissingTranslation handler
//
//

@Injectable({
    providedIn: 'root'
})
export class VTranslateService {
    readonly translation = signal<any>({});
    readonly injector = inject(Injector);

    readonly templateMatcher: RegExp = /{{\s?([^{}\s]*)\s?}}/g;

    private getTransformedValue(key: string, target: any): string | undefined {
        const [skey, format, ...subformat] = typeof key === 'string' ? key.split(':') : [key, undefined, undefined];
        const splits = skey.split('.');
        let tdata = target;
        for (let i = 0; i < splits.length; i++)
            tdata = tdata?.[splits[i]];
        if (!format || !tdata)
            return tdata;
        return GcTranslateParser.formatParsers[format](tdata, subformat.join(':'));
    }

    private parseValue(tdata: string, data: any) {
        if (!data)
            return tdata;

        return tdata.replace(this.templateMatcher, (substring: string, token: string) => {
            return this.getTransformedValue(token, data) ?? substring;
        });
    }

    public async loadTranslation(lang: string) {
        const f = await fetch('/assets/i18n/' + lang + '.json');

        const fetchData: any = await f.json();
        //console.log("TransalationData:", fetchData);
        this.setTranslation(fetchData);
    }

    public setTranslation(translation: any) {
        this.translation.set(translation);
    }

    readonly INLINE_REGEX = /^#\(.*\)#$/;
    public asSignal<T>(token: string, data?: T): Signal<string> {
        //console.log("TranslationRequest: ", token, data);
        return computed(() => {
            const tok = token.split('.');
            let tdata = this.translation();
            //console.log("splits:", tok, tdata);
            for (let i = 0; i < tok.length; i++) {
                //console.log(tok[i], tdata[tok[i]]);
                if (tdata[tok[i]] === undefined) {
                    if (!this.INLINE_REGEX.test(token))
                        return token;
                    tdata = token.substring(2, token.length - 2);
                    break;
                }
                tdata = tdata[tok[i]];
            }
            //console.log("tdata: ", tdata);
            if (tdata === undefined)
                return token;
            if (typeof tdata === 'function')
                return tdata(data);
            if (typeof tdata === 'object')
                return tdata;
            return this.parseValue(tdata, data);
        });
    }

    public stream<T>(token: string[], data?: T): Observable<Record<string, string>>;
    public stream<T>(token: string, data?: T): Observable<string>;
    public stream(token: string | string[], data?: unknown): Observable<string> | Observable<Record<string, string>> {
        // since instant uses signals internally, the computed will bind to them and recompute
        return toObservable(computed(() => this.instant(token as string, data)));
    }

    public instant<T>(token: string, data?: T): string;
    public instant<T>(token: string[], data?: T): Record<string, string>;
    public instant(token: string | string[], data: unknown): string | Record<string, string> {
        if (Array.isArray(token)) {
            return token.reduce((acc, cur) => {
                acc[cur] = this.asSignal(cur, data)();
                return acc;
            }, {} as Record<string, string>);
        } else {
            return this.asSignal(token,data)();
        }
    }
}